import { render, staticRenderFns } from "./RsaPazientePrescrizioneFarmaciTabModalComponent.vue?vue&type=template&id=0104d258&scoped=true"
import script from "./RsaPazientePrescrizioneFarmaciTabModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePrescrizioneFarmaciTabModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0104d258",
  null
  
)

export default component.exports